const parseFB = (scope) => {
  if (window.FB && window.FB.XFBML) { window.FB.XFBML.parse(scope); }
};

export default parseFB;
